import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss']
})
export class CreateUserComponent implements OnInit {
  hide = true;
  hide1 = true;
  newUserData = new FormGroup({
    firstName: new FormControl('', Validators.required),
    lastName: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
    phone: new FormControl('', [Validators.required, Validators.pattern(/^\+[1-9]{1}[0-9]{3,14}$/)]),
    passwordCreate: new FormControl('', [Validators.required, Validators.minLength(6) ]),
    conformPassword: new FormControl('', Validators.required),
    division: new FormControl('')
  });
  updateUserData = new FormGroup({
    firstName: new FormControl('', Validators.required),
    lastName: new FormControl('', Validators.required),
    division: new FormControl('')
  })
  companyId;
  role = [];
  passwordMatch;
  confromPassword;
  userInfo = JSON.parse(localStorage.getItem('User'));
  userRole = this.userInfo.roles[0];
  type;
  usertoEdit;
  constructor(
    public dialogRef: MatDialogRef<CreateUserComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar
  ) { 
    this.companyId = data.companyId;
    this.role=data.role;
    this.type = data.type;
    this.usertoEdit = data.usertoEdit;
    console.log(this.usertoEdit);
  }

  ngOnInit(): void {
    if (this.type === 'edit' && this.usertoEdit) {
      this.updateUserData.controls['firstName'].setValue(this.usertoEdit.first_name);
      this.updateUserData.controls['lastName'].setValue(this.usertoEdit.last_name);
      this.updateUserData.controls['division'].setValue(this.usertoEdit.division);
    }
  }

  handleCreateNewUser(){
    if (this.newUserData.valid && this.passwordMatch=='match') {
      debugger;
      const signupData = {
        ...this.newUserData.value,
      }
      let roles = [];
      if(this.userRole == 'root'){
        roles = this.role;
      }else{
        roles = ['user'];
      }
      let createUser = {
        first_name: this.newUserData.get('firstName').value,
        last_name: this.newUserData.get('lastName').value,
        email: this.newUserData.get('email').value,
        phone: this.newUserData.get('phone').value,
        password: this.newUserData.get('passwordCreate').value,
        company_id: this.companyId,
        roles: roles,
        division: this.newUserData.get('division').value,
      }
      this._apiService.createUser(createUser).subscribe(user => {
        if (user && user.authorization) {
          this._snackBar.open('User created', 'OK', { duration: 3000 })
        }
      },
      (error)=>{
        console.log(error);
      });
      this.dialogRef.close();
    }else if(this.passwordMatch == 'notmatch'){
      this._snackBar.open('Please check your password and try again!', 'OK', { duration: 3000 });
    }
  }

  handleUpdateUser(){
    if (this.updateUserData.valid){
      let updateUser = {
        first_name: this.updateUserData.get('firstName').value,
        last_name: this.updateUserData.get('lastName').value,
        division: this.updateUserData.get('division').value,
        id:this.usertoEdit.id
      }

      this._apiService.updateUserName(updateUser).subscribe(res => {
        if (res) {
          console.log(res);
          this._snackBar.open('User Updated Successfully', 'OK', { duration: 3000 })
        }
      },
      (error)=>{
        console.log(error);
      });
      this.dialogRef.close();
    }
  }
  

  onConformPassword(e){
    if(this.newUserData.get('passwordCreate').value != this.newUserData.get('conformPassword').value){
      this.passwordMatch = 'notmatch'
    }else if(this.newUserData.get('passwordCreate').value == this.newUserData.get('conformPassword').value){
      this.passwordMatch = 'match'
    }
  }

  close(){
    this.dialogRef.close();
  }

}
